"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CartService.$inject = ['api', 'extApi', '$q', '$rootScope', 'Popeye'];
function CartService(api, extApi, $q, $rootScope, Popeye) {
    var service = {};
    service.update = function (product, data) {
        return api.update('/b2b/cart/' + product.cart_id, data);
    };
    service.remove = function (product) {
        return api.remove('/b2b/cart/' + product.cart_id);
    };
    service.add = function (data) {
        return api.post('/b2b/cart/', data);
    };
    service.setCartTotal = function (total) {
        $rootScope.cart_total = total;
    };
    service.setCartTotalVat = function (total_vat) {
        $rootScope.cart_total_vat = total_vat;
    };
    service.setCartSize = function (size) {
        $rootScope.cart_size = size;
    };
    service.setCartTotalQuantity = function (total) {
        $rootScope.cart_total_quantity = total;
    };
    service.reserveModal = function (orderData, autoConfirm) {
        if (autoConfirm === void 0) { autoConfirm = false; }
        var delay = $q.defer();
        var modal = Popeye.openModal({
            template: require('../views/reservation-modal.html'),
            containerClass: 'modal-priority',
            modalClass: 'order-reservation-modal',
            controller: ['$scope', function ($scope) {
                    $scope.saving = autoConfirm;
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.save = function () {
                        $scope.saving = true;
                        extApi.post('/orders', orderData)
                            .then(function (response) {
                            $scope.ok(response);
                        }, function (error) {
                            $scope.cancel(error);
                            Popeye.closeCurrentModal(error);
                        });
                    };
                    if (autoConfirm) {
                        $scope.save();
                    }
                }]
        });
        modal.closed.then(function () {
            delay.reject();
        });
        return delay.promise;
    };
    service.updateTotal = function () {
        api.get('/b2b/cart/total').then(function (response) {
            service.setCartTotal(response.total);
            service.setCartTotalVat(response.total_vat);
            service.setCartSize(response.cart_size);
            service.setCartTotalQuantity(response.quantity_total);
        }, function (error) {
            console.log('error');
        });
    };
    return service;
}
exports.CartService = CartService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/cart/services/cart.js
// module id = 426
// module chunks = 0